export default "/react/logoCopyMonkey-37a2d817.png";